module.exports = __webpack_public_path__ + "static/team-1-e90c53acdee60a36f6a780265e9a7022.png";